import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const couponsChangeddConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.COUPONS_CHANGED,
  handler: ({ detail }) => {
    logger('Coupons Changed');
    console.log(detail);
  },
};
